import Category from '@shared/classes/category';
import { store } from '../../store/store';
import { updateCategories as updateCategoriesAction } from '../../store/slices/categories.slice';

function updateCategories(value: Category[]) {
  store.dispatch(updateCategoriesAction(value));
}

export default updateCategories;
